import React, { useState } from "react";
import Flag from "react-world-flags";
import CustomSwitch from "../../../../controls/CustomSwitch";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoWarning } from "react-icons/io5";

export default function EntryRequirementVaccine({ mainColor, tripCountries }) {
  const [selectedItems, setSelectedItems] = useState([]);

  const selectionItems = [
    {
      id: 1,
      name: "Yellow Fever Vaccine",
      desc: "Official entry requirement",
      price: "57.00",
    },
    {
      id: 2,
      name: "ICVP Certificate",
      desc: "Official entry requirement",
      price: "FREE",
    },
    {
      id: 3,
      name: "Typhoid Vaccine",
      desc: "Recommended for travel to certain areas",
      price: "42.00",
    },
    {
      id: 4,
      name: "Hepatitis A Vaccine",
      desc: "Strongly recommended for food and water safety",
      price: "60.00",
    },
    {
      id: 5,
      name: "Tetanus Booster",
      desc: "Recommended if last dose was over 10 years ago",
      price: "35.00",
    },
  ];

  const handleBoxClick = (id, name) => {
    const isAlreadySelected = selectedItems.some((i) => i.id === id);

    if (isAlreadySelected) {
      setSelectedItems((prev) => prev.filter((item) => item.id !== id));
    } else {
      setSelectedItems((prev) => [...prev, { id: id, name: name }]);
    }
  };

  return (
    <div className="vaccine-suggestion-box entry-requirement-box">
      <div className="top-header">
        <p>Entry Requirement</p>
        <IoWarning size={18} />
      </div>
      <div className="body">
        <div className="header">
          <p>Yellow Fever Vaccine</p>
          <div className="flags">
            {tripCountries.map((country) => (
              <div className="flag-container">
                <Flag key={country.code} code={country.code} />
              </div>
            ))}
          </div>
        </div>

        <div className="content">
          <p className="description">
            Country requires proof of Yellow Fever Vaccination for entry. You
            must present an International Certificate of Vaccination or
            Prophylaxis (ICVP) when you arrive. Without this certificate, entry
            may be refused.
          </p>

          <div className="switch-box">
            <div>
              <p className="title">I already have this vaccine</p>
              <p className="subtitle">
                Already vaccinated? Bring your certificate with you
              </p>
            </div>
            <CustomSwitch mainColor={mainColor} />
          </div>

          <div className="selection-items-wrapper">
            <p className="heading">Select items you're interested in</p>

            <div className="boxes">
              {selectionItems.map((item) => {
                const isSelected = selectedItems.some((i) => i.id === item.id);

                return (
                  <div
                    className={`vaccine-selection-box ${
                      isSelected ? "selected" : ""
                    }`}
                    style={{
                      border: `1px solid ${isSelected ? mainColor : "#cecece"}`,
                    }}
                    key={item.id}
                    onClick={() => handleBoxClick(item.id, item.name)}
                  >
                    <div>
                      <p className="title">{item.name}</p>
                      <p className="subtitle">{item.desc}</p>
                    </div>

                    <div className="price-checkmark">
                      <p className="price">
                        {item.price !== "FREE" && "£"}
                        {item.price}
                      </p>
                      {isSelected ? (
                        <IoIosCheckmarkCircle
                          className="checkmark"
                          color={mainColor}
                          size={22}
                        />
                      ) : (
                        <div className="empty-circle"></div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
